// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(_state, action) {
  if (action) {
    return /* Error */{
            _0: action._0
          };
  } else {
    return /* Submitting */1;
  }
}

export {
  reducer ,
  
}
/* No side effect */
